import { useContext } from 'react';

import { Text } from '@gympass/yoga';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { SpecialistContext, usePermissionConfig } from 'context';
import { getSpecialistType } from 'context/SpecialistContext/SpecialistContext';
import { SpecialistType } from 'services/specialist';

import { Loading } from 'components';

import PhaseOut from './components/PhaseOut';
import * as S from './style';

import { NotesSectionProps, NoteType } from './types';

const NotesSection: React.FC<NotesSectionProps> = ({
  isLoading,
  noteType = NoteType.NOTES,
}) => {
  const { specialistInfo } = useContext(SpecialistContext);
  const specialistType = getSpecialistType(specialistInfo?.groups);
  const { hasAccess } = usePermissionConfig();

  const isNotesType = noteType === NoteType.NOTES;

  const shouldShowPhaseOutOnLogbook =
    noteType === NoteType.LOGBOOK && specialistType === SpecialistType.TC;
  const shouldShowPhaseOutOnNote = isNotesType;

  if (isNotesType && !hasAccess(noteType)) return <></>;

  return (
    <S.NotesSection data-testid="notesSection">
      <S.NotesWrapper>
        <Loading isLoading={isLoading} />
        <Text.H5 data-testid="notesTitle">
          <FormattedMessage
            id={isNotesType ? 'ENDUSER.NOTES' : 'ENDUSER.LOGBOOK'}
          />
        </Text.H5>
        <S.NotesContent>
          <Link to={`${isNotesType ? 'notes' : 'logbook'}`}>
            <S.NotesViewButton data-testid="notesViewButton">
              <FormattedMessage
                id={
                  isNotesType
                    ? 'ENDUSER.NOTES.BUTTON.VIEW'
                    : 'ENDUSER.LOGBOOK.BUTTON.VIEW'
                }
              />
            </S.NotesViewButton>
          </Link>
        </S.NotesContent>
      </S.NotesWrapper>
      {shouldShowPhaseOutOnLogbook && <PhaseOut />}
      {shouldShowPhaseOutOnNote && <PhaseOut />}
    </S.NotesSection>
  );
};

export default NotesSection;
